<template>
	<div>111</div>
</template>
<script>
export default {
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.$router.replace(from.path);
		});
	},
};
</script>
